import { activeShoppingShareItems, type ShoppingListItem } from "./shopping-list";

/** Public Mini App rollout; the Worker still authenticates every share. */
export const SHOPPING_SHARING_ENABLED = true;
// Deliberately bounded below Telegram Rich Messages' 50-media platform limit.
export const SHOPPING_SHARE_PHOTO_LIMIT = 10;
export function shoppingSharingAvailable(website: boolean): boolean {
  // The standalone website has no Telegram session for prepared photo messages.
  return SHOPPING_SHARING_ENABLED && !website;
}

export interface ShoppingShareScope {
  kind: "active";
  /** Exact store name, never a fuzzy match. Omitted means all stores. */
  store?: string;
}

export function parseShoppingShareScope(value: unknown): ShoppingShareScope | null {
  if (!value || typeof value !== "object" || Array.isArray(value)) return null;
  const scope = value as Record<string, unknown>;
  if (scope.kind !== "active" || Object.keys(scope).some((key) => key !== "kind" && key !== "store")) return null;
  if (scope.store === undefined) return { kind: "active" };
  if (typeof scope.store !== "string" || !scope.store.trim() || scope.store.length > 80) return null;
  return { kind: "active", store: scope.store };
}

export function scopedShoppingShareItems(
  items: readonly ShoppingListItem[], today: string, scope: ShoppingShareScope,
): ShoppingListItem[] {
  return activeShoppingShareItems(items, today).filter((item) => scope.store === undefined || item.store === scope.store);
}
